import {
	ADD_STATIONS,
	CITIES_LAYERS,
	DEPARTMENTS_LAYERS,
	MANAGEMENT_WATER_LAYERS,
	PANEL_CITY,
	PANEL_DRAW,
	PANEL_LAYER,
	PANEL_RADIUS,
	PUT_STATIONS,
	RECEIVE_CITY_INDICATORS,
	RECEIVE_CITY_INFORMATIONS,
	RECEIVE_KEY_FIGURES,
	RECEIVE_KEY_FIGURES_SAMPLING_POINTS,
	RECEIVE_RESEARCH_TYPE,
	RECEIVE_WATERSHED_SELECTED,
	RESET_RESEARCH,
	RESET_STATIONS,
	SELECTED_STATIONS,
	SELECTED_TYPES,
	SET_HOVER,
	SET_OLD_VALUE,
	SET_RADIUS,
	SET_SELECTED_VALUE,
	SET_VISUALISATION,
	UPDATE_CITIES_LAYERS,
	UPDATE_MANAGEMENT_WATER_LAYERS,
	UPDATE_WATERSHED_LAYERS,
	WATERSHED_LAYERS
} from '../constants/SitesConstants'
import ApplicationConf from '../../conf/ApplicationConf'
import fetch from 'isomorphic-fetch'
import { checkStatus } from '../../utils/ActionUtils'
import HomeAction from '../../home/actions/HomeAction'
import { WaitAction } from 'react-aquasys'
import { getFetchSiteIds, getFetchSiteTypeAllowWithTypes } from '../../utils/ApplicationUtils'
import { PATH_RESEARCH } from '../../home/constants/HomeConstants'
import { push } from 'react-router-redux'
import SiteTypes from '../../utils/mapUtils/SiteTypes'
import reduce from 'lodash/reduce'
import AppStore from '../../store/AppStore'
import flatMap from 'lodash/flatMap'
import { find, flatten, flattenDeep, matchesProperty, remove } from 'lodash'
import { createDtoFilter } from '../../utils/ResearchTypesUtils'
import { getSiteTypesSelected } from '../../utils/ThemesUtils'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import i18n from 'simple-react-i18n'
import SelectionAction from '../../dashboard/actions/SelectionAction'
import ToastrAction from '../../home/actions/ToastrAction'
import InformationAction from '../../home/actions/InformationAction'

const selectedTypes = [{
	type: SiteTypes.QUALITOMETER.type,
	checked: true
}, {
	type: SiteTypes.QUALITOMETER_SURFACE.type,
	checked: true
}, {
	type: SiteTypes.PIEZOMETER.type,
	checked: true
}, {
	type: SiteTypes.POLLUTED_SOIL.type,
	checked: true
}, {
	type: SiteTypes.INDUSTRIAL_SITE.type,
	checked: true
}]

const RESEARCH_TYPES = [
	{
		type: PANEL_CITY,
		title: 'Recherche par critère géographique',
		icon: 'location_city',
		comment: 'Recherche par critères géographiques. Rechercher en saisant le code ou le nom.',
		inDevelop: false
	},
	{
		type: PANEL_RADIUS,
		title: 'Recherche par périmètre',
		icon: 'filter_tilt_shift',
		inDevelop: false,
		comment: 'Recherche par périmètre. Cliquez sur la carte et tracez un cercle à partir de ce point. La zone de recherche est limitée à 20km.'
	},
	{
		type: PANEL_DRAW,
		title: 'Recherche par polygone',
		icon: 'mode_edit',
		inDevelop: true,
		comment: 'Désiner la forme que vous souhaitez et la recherche se fera dans la zone que vous avez déssinez'
	},
	{
		type: PANEL_LAYER,
		title: 'Recherche par KML',
		icon: 'insert_photo',
		inDevelop: true,
		comment: 'Uploder un KML et la recherche se fera sur ce KML'
	}
]

const SitesAction = {


	receiveStations: function (content, idWatershed, selection) {
		return {
			type: ADD_STATIONS,
			stations: content,
			selection: selection
		}
	},
	putStations: function (content) {
		return {
			type: PUT_STATIONS,
			stations: content
		}
	},

	setSelectedStations: function (content) {
		return {
			type: SELECTED_STATIONS,
			selectedStations: content
		}
	},

	toggleSelectedStations: station => {
		return dispatch => {
			const selectedStations = Object.assign([], AppStore.getState().SitesReducer.selectedStations)
			const res = find(selectedStations, matchesProperty('id', station.id))
			if (res) {
				remove(selectedStations, s => {
					return s.id === station.id
				})
				dispatch(SitesAction.setSelectedStations(selectedStations))
			} else {
				selectedStations.push(station)
				dispatch(SitesAction.setSelectedStations(selectedStations))
			}
		}
	},
	receiveSelectedTypes: function (selected) {
		return {
			type: SELECTED_TYPES,
			selectedTypes: selected
		}
	},

	fetchSelectedTypes: function () {
		return function (dispatch) {
			dispatch(SitesAction.receiveSelectedTypes(selectedTypes))
		}
	},


	launchResearch(selectedFilters, selectedThemes, filterTypes, selection = undefined) {
		AppStore.dispatch(AdministrationAction.selectedThemes(selectedThemes))
		AppStore.dispatch(AdministrationAction.selectedFilters(selectedFilters))
		AppStore.dispatch(SitesAction.resetStations())
		if (selection) {
			AppStore.dispatch(SelectionAction.setSelectedSelection(selection))
			AppStore.dispatch(SelectionAction.updateExecution(selection.id))
		}
		if (selectedFilters.length && selectedThemes.length) {
			const filterTypeDto = selectedFilters.map((o) => {
				return createDtoFilter(filterTypes, o)
			})
			AppStore.dispatch(SitesAction.prepareFetchTypeResearch(filterTypeDto, getSiteTypesSelected(selectedThemes), selection))
		} else {
			if (!selectedFilters.length) {
				AppStore.dispatch(ToastrAction.warning(i18n.warning.pleaseFillLeastFilter))
			} else if (!selectedThemes.length) {
				AppStore.dispatch(ToastrAction.error(i18n.error.pleaseFillLeastTheme))
			}
		}
	},

	prepareFetchTypeResearch: function (filters, siteTypesSelected, selection) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			dispatch(InformationAction.message(i18n.dataRecuperation))
			const reducerFilterType = reduce(filters, (a, b) => {
				(a[b.filterTypeId] || (a[b.filterTypeId] = [])).push(b)
				return a
			}, {})
			const fetchTab = flatMap(Object.keys(reducerFilterType), (o) => {
				switch (o.toString()) {
					case '1':
						return SitesAction.prepareCityFilter(reducerFilterType[o], siteTypesSelected, selection)
					case '2':
						return SitesAction.prepareRadiusFilter(reducerFilterType[o], siteTypesSelected, selection)
					case '65537':
						return SitesAction.prepareStationFilter(reducerFilterType[o], selection)
					case '65536':
						return SitesAction.prepareWatershedFilter(reducerFilterType[o], siteTypesSelected, selection)
					case '98304':
						return SitesAction.prepareManagementWaterFilter(reducerFilterType[o], siteTypesSelected, selection)
					case '131072':
						return SitesAction.prepareDepartmentFilter(reducerFilterType[o], siteTypesSelected, selection)
					default:
						return []
				}
			})
			fetchTab.push(AdministrationAction.updateEntry(''))
			const allfetch = fetchTab.map((o) => {
				return AppStore.dispatch(o)
			})
			Promise.all(allfetch)
			AppStore.dispatch(push(PATH_RESEARCH))
		}
	},

	prepareCityFilter: function (tabFilter, siteType, selection) {
		return tabFilter.map((o) => {
			return SitesAction.fetchStationsByCity(o.value, siteType, selection)
		})
	},
	prepareDepartmentFilter: function (tabFilter, siteType, selection) {
		return tabFilter.map((o) => {
			return SitesAction.fetchStationsByDepartment(o.value, siteType, selection)
		})
	},
	prepareManagementWaterFilter: function (tabFilter, siteType, selection) {
		return tabFilter.map((o) => {
			return SitesAction.fetchStationsBySage(o.value, siteType, selection)
		})
	},
	prepareRadiusFilter: function (tabFilter, siteType, selection) {
		return tabFilter.map((o) => {
			return SitesAction.fetchStationsByRadius(o.value, siteType, selection)
		})
	},
	prepareStationFilter: function (tabFilter, selection) {
		return tabFilter.map((o) => {
			return SitesAction.fetchSimpleStationWaterShed(o.value, selection)
		})
	},
	prepareWatershedFilter: function (tabFilter, siteType, selection) {
		return tabFilter.map((o) => {
			return SitesAction.fetchDispatchStationsByWatershedSimple(o.value, siteType, selection)
		})
	},
	fetchStationsByCity: function (code, selectedType, selection) {
		return function (dispatch) {
			return fetch(ApplicationConf.sites.getCityWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						inseecode: code
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.getStations(json, selectedType, selection))
				})
		}
	},
	fetchStationsByDepartment: function (code, selectedType, selection) {
		return function (dispatch) {
			return fetch(ApplicationConf.sites.getDepartmentWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						departmentcode: code
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.getStations(json, selectedType, selection))
				})
		}
	},
	fetchStationsBySage: function (code, selectedType, selection) {
		return function (dispatch) {
			return fetch(ApplicationConf.sites.getSageWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						sagecode: code
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.getStations(json, selectedType, selection))
				})
		}
	},
	fetchStationsByRadius: function (coordinatesWithRadius, selectedType, selection) {
		return (dispatch) => {
			return fetch(ApplicationConf.sites.getRadiusWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(coordinatesWithRadius)
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.getStations(json, selectedType, selection))
				})
		}
	},

	fetchOnDemandKeyfigures: function (stations) {
		return dispatch => {
			AppStore.dispatch(WaitAction.waitStart())
			const stationIds = stations.map(o => o.id)
			const cities = stations.filter(o => {
				return o.typeId == 335715375
			})
			const citiesId = cities.map(o => o.id)
			const citiesCode = cities.map(o => o.code)
			dispatch(SitesAction.fetchCityIndicators(citiesId))
			dispatch(SitesAction.fetchCityInformations(citiesCode))
			dispatch(SitesAction.fetchKeyFigures(stationIds))
			AppStore.dispatch(WaitAction.waitStop())
		}
	},

	getStations: function (jsonIdWatershed, selectedType, selection) {
		return dispatch => {
			const listOfWatershedIds = jsonIdWatershed.map(waterShed => waterShed.id)
			const finalListOfWatershed = flatten(listOfWatershedIds.map((id) => {
				return SitesAction.fetchDispatchGetWatershedChild(id)
			}))
			Promise.all(finalListOfWatershed).then((resultOfChild) => {
				const listOfWatershed = flatten(resultOfChild)
				dispatch(SitesAction.receiveWatershedSelected(listOfWatershed))
				return flatten(listOfWatershed.map((watershed) => {
					return SitesAction.fetchStationsByWatershed(watershed.id, selectedType)
				}))
			}).then(values => {
				dispatch(InformationAction.message(i18n.mapGenerate))
				Promise.all(values).then((resultOfChild) => {
					dispatch(SitesAction.receiveStations(flattenDeep(resultOfChild), selection))
				}).then(() => {
					AppStore.dispatch(WaitAction.waitStop())
				}).catch(() => {
					AppStore.dispatch(WaitAction.waitStop())
				})
			})
		}
	},

	fetchSimpleStationWaterShed: function (id, selection) {
		return function (dispatch) {
			return fetch(ApplicationConf.sites.getSimpleStationWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idpoint: id
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					const watershedId = json && json.length ? json[0].id : undefined
					dispatch(SitesAction.receiveWatershedSelected(json))
					dispatch(SitesAction.fetchSimpleStation(id, watershedId, selection))
				})
		}
	},

	fetchSimpleStation: function (id, idWatershed, selection) {
		return (dispatch) => {
			return fetch(ApplicationConf.sites.getSimpleStationResearch(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					idstation: id
				})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.receiveStations(json, idWatershed, selection))
					return json
				}).then((json) => {
					dispatch(SitesAction.fetchKeyFigures([json.id]))
				}).catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchSimpleStation' + err))
				})
		}
	},

	receiveWatershedSelected: function (watershedSelected) {
		return {
			type: RECEIVE_WATERSHED_SELECTED,
			watershedSelected: watershedSelected
		}
	},

	fetchStationsByWatershed: function (idwatershed, selectedType) {
		return fetch(ApplicationConf.sites.getByWatershed(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idwatershed: idwatershed,
					parametertype: getFetchSiteTypeAllowWithTypes(selectedType)
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => []),
				404: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	fetchDispatchGetWatershedChild: function (idwatershed) {
		return fetch(ApplicationConf.sites.getChildWatershed(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idwatershed: idwatershed
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => []),
				404: (() => [])
			}, response))
			.then((json = []) => {
				return json
			})
	},
	fetchDispatchStationsByWatershedSimple: function (idwatershed, selectedType, selection) {
		return (dispatch) => {
			return fetch(ApplicationConf.sites.getWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idwatershed: idwatershed
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.getStations(json, selectedType, selection))
				})
		}
	},
	fetchDispatchStationsByWatershed: function (idwatershed, selectedType, selection) {
		return (dispatch) => {
			return fetch(ApplicationConf.sites.getByWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idwatershed: idwatershed,
						parametertype: getFetchSiteTypeAllowWithTypes(selectedType)
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.receiveStations(json, idwatershed, selection))
					return json
				}).then((json = []) => {
					const stationId = json.map(o => o.id)
					dispatch(SitesAction.fetchKeyFigures(stationId))
				})
		}
	},


	receiveKeyFigures: function (keyFigures) {
		return {
			type: RECEIVE_KEY_FIGURES,
			keyFigures: keyFigures
		}
	},
	fetchKeyFigures: function (stationIds) {
		return (dispatch) => {
			return fetch(ApplicationConf.sites.getKeyFigures(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						stationids: getFetchSiteIds(stationIds)
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.receiveKeyFigures(json))
					return json
				})
				.then(json => {
					const samplingIds = json.filter(o => o.samplingid).map(o => o.samplingid)
					if (samplingIds.length) {
						dispatch(SitesAction.fetchSamplingPoints(samplingIds))
					}
				}).then(() => {
					AppStore.dispatch(WaitAction.waitStop())
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchKeyFigures' + err))
				})
		}
	},
	receiveCityIndicators: function (cityIndicators) {
		return {
			type: RECEIVE_CITY_INDICATORS,
			cityIndicators: cityIndicators
		}
	},
	fetchCityIndicators: function (stationIds) {
		return (dispatch) => {
			return fetch(ApplicationConf.city.getIndicators(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						citypointid: getFetchSiteIds(stationIds)
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					if (json.length) {
						dispatch(SitesAction.receiveCityIndicators(json))
					}
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchCityIndicators' + err))
				})
		}
	},
	receiveCityInformations: function (cityInformations) {
		return {
			type: RECEIVE_CITY_INFORMATIONS,
			cityInformations: cityInformations
		}
	},
	fetchCityInformations: function (stationCode) {
		return (dispatch) => {
			return fetch(ApplicationConf.city.getInformations(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						citypointcode: getFetchSiteTypeAllowWithTypes(stationCode)
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					if (json.length) {
						dispatch(SitesAction.receiveCityInformations(json))
					} else {
						dispatch(ToastrAction.warning(i18n.warning.noInformationAvailableMunicipalities))
					}
				})
				.catch(err => {
					dispatch(HomeAction.errorOnFetch('fetchCityIndicators' + err))
				})
		}
	},

	fetchSamplingPoints: (ids = []) => {
		return dispatch => {
			return fetch(ApplicationConf.sites.getSamplingPoints(ids.join(',')))
				.then(response => checkStatus({
					200: (rep => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(SitesAction.receiveSamplingPoints(json))
				})
		}
	},

	receiveSamplingPoints: samplingPoints => {
		return { type: RECEIVE_KEY_FIGURES_SAMPLING_POINTS, samplingPoints: samplingPoints }
	},
	receiveResearchTypes: function (researchTypes) {
		return { type: RECEIVE_RESEARCH_TYPE, researchTypes: researchTypes }
	},
	fetchResearchTypes() {
		return dispatch => {
			dispatch(SitesAction.receiveResearchTypes(RESEARCH_TYPES))
		}
	},
	setOldValue: function (oldValue) {
		return {
			type: SET_OLD_VALUE,
			oldValue: oldValue
		}
	},
	setSelectedValue: function (selectedValue) {
		return {
			type: SET_SELECTED_VALUE,
			selectedValue: selectedValue
		}
	},
	setVisualisation: function (visualisation) {
		return {
			type: SET_VISUALISATION,
			visualisation: visualisation
		}
	},
	setRadius: function (radius) {
		return {
			type: SET_RADIUS,
			radius: radius
		}
	},
	setCoordinatesHover: function (hover) {
		return {
			type: SET_HOVER,
			hover: hover
		}
	},
	addWatershedLayers: function (watershedLayers) {
		return {
			type: WATERSHED_LAYERS,
			watershedLayers: watershedLayers
		}
	},
	updateWatershedLayers: function (watershedLayers) {
		return {
			type: UPDATE_WATERSHED_LAYERS,
			watershedLayers: watershedLayers
		}
	},
	addManagementWaterLayers: function (managementWaterLayers) {
		return {
			type: MANAGEMENT_WATER_LAYERS,
			managementWaterLayers: managementWaterLayers
		}
	},
	updateManagementWaterLayers: function (managementWaterLayers) {
		return {
			type: UPDATE_MANAGEMENT_WATER_LAYERS,
			managementWaterLayers: managementWaterLayers
		}
	},
	addCitiesLayers: function (citiesLayers) {
		return {
			type: CITIES_LAYERS,
			citiesLayers: citiesLayers
		}
	},
	addDepartmentsLayers: function (departmentsLayers) {
		return {
			type: DEPARTMENTS_LAYERS,
			departmentsLayers: departmentsLayers
		}
	},
	updateCitiesLayers: function (citiesLayers) {
		return {
			type: UPDATE_CITIES_LAYERS,
			citiesLayers: citiesLayers
		}
	},
	reset() {
		return {
			type: RESET_RESEARCH
		}
	},
	resetStations() {
		return {
			type: RESET_STATIONS
		}
	}

}

export default SitesAction



// WEBPACK FOOTER //
// ./src/sites/actions/SitesAction.js